var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRecording01(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "evenodd",
    d: "M1 7C1.55228 7 2 7.44772 2 8L2 12C2 12.5523 1.55228 13 1 13 .44772 13 0 12.5523 0 12L0 8C0 7.44772.44772 7 1 7ZM5.5 3C6.05228 3 6.5 3.44772 6.5 4L6.5 16C6.5 16.5523 6.05229 17 5.5 17 4.94772 17 4.5 16.5523 4.5 16L4.5 4C4.5 3.44772 4.94772 3 5.5 3ZM10 0C10.5523 0 11 .44772 11 1L11 19C11 19.5523 10.5523 20 10 20 9.4477 20 9 19.5523 9 19L9 1C9 .44772 9.4477 0 10 0ZM14.5 3C15.0523 3 15.5 3.44772 15.5 4L15.5 16C15.5 16.5523 15.0523 17 14.5 17 13.9477 17 13.5 16.5523 13.5 16L13.5 4C13.5 3.44772 13.9477 3 14.5 3ZM19 7C19.5523 7 20 7.44772 20 8L20 12C20 12.5523 19.5523 13 19 13 18.4477 13 18 12.5523 18 12L18 8C18 7.44772 18.4477 7 19 7Z",
    transform: "translate(2 2)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecording01);
export default __webpack_public_path__ + "static/media/recording-01.24deb3f8d652ccd32825af2ba4a1172b.svg";
export { ForwardRef as ReactComponent };